type IsLoyaltyProgramVisibleOptions = {
  patronLoyaltyEnabled: boolean;
  supportsPublic: boolean;
  isEnrolled: boolean;
  isProgramActive: boolean;
};

export const isLoyaltyProgramVisible = ({
  patronLoyaltyEnabled,
  supportsPublic,
  isEnrolled,
  isProgramActive,
}: IsLoyaltyProgramVisibleOptions) =>
  patronLoyaltyEnabled && supportsPublic && isEnrolled && isProgramActive;
